// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__1YhL4","menu":"NavBar_menu__3GLgk","item":"NavBar_item__WEh28","darkTheme":"NavBar_darkTheme__38FD0"};